/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

import CookieConsent from './CookieConsent';
import Footer from './Footer';
import MembershipExpiryReminder from './MembershipExpiryReminder';
import ProductSwitcher from './ProductSwitcher';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export {
  AvatarDropdown,
  AvatarName,
  CookieConsent,
  Footer,
  MembershipExpiryReminder,
  ProductSwitcher,
  Question,
  SelectLang,
};
